import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { GridBreakpoints } from '../../constants/breakpoints';
import { setInterval, clearInterval, setTimeout } from 'timers';
import debounce from 'core/decorators/debounce';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        Vnodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes
        }
    }
})
export class CustomCarouselComponent extends Vue {
    @Prop({ default: false })
    cycle: boolean;

    @Prop({ default: false })
    hideControls: boolean;

    @Prop({ default: true })
    hideDelimiters: boolean;

    @Prop({ default: true })
    infinite: boolean;

    @Prop()
    breakpoint: string;

    @Prop({ type: [Number, String], default: 'auto' })
    height: number | string;

    @Prop([Number, String])
    maxWidth: number | string;

    @Prop({ default: false })
    branded: boolean;

    @Prop({ type: [Number, String], default: 6000 })
    interval: number;

    isMounted: boolean =  false;
    carouselIsActive: boolean = false;
    carouselHeight: number = 0;

    activeItemWidth: string = 'auto';
    activeItemHeight: string = 'auto';

    indexOfActiveCarouselItem: number = 0;
    prevArrow: any = undefined;
    nextArrow: any = undefined;

    get carouselItems() {
        return this.$slots.default!.filter(e => e.tag != undefined);
    }

    get carouselStyleHeight() {
        if (this.height == 'auto') {
            return this.activeItemHeight;
        }
        if (this.height && !isNaN(Number(this.height))) {
            return `${this.height}px`;
        }
        if (this.height && isNaN(Number(this.height))) {
            return this.height;
        }

        return '';
    }

    get carouselStyleMaxWidth() {
        if (this.maxWidth && !isNaN(Number(this.maxWidth))) {
            return `${this.maxWidth}px`;
        }
        if (this.maxWidth && isNaN(Number(this.maxWidth))) {
            return this.maxWidth;
        }

        return '';
    }

    mounted() {
        this.actualizeActiveItemSize();

        const elements = Array.from(this.$el.children);
        const elementsHeights = elements.map((element) => element.clientHeight);

        this.carouselHeight = Math.max(...elementsHeights);

        const scanForPrevArrowInterval = setInterval(() => {
            const prevArrow = (this.$el.getElementsByClassName('v-carousel__prev')[0] as HTMLElement);

            if (prevArrow) {
                this.prevArrow = prevArrow;
                this.toggleLastArrow(this.indexOfActiveCarouselItem);
                clearInterval(scanForPrevArrowInterval);
            }
        }, 100);
        const scanForNextArrowInterval = setInterval(() => {
            const nextArrow = (this.$el.getElementsByClassName('v-carousel__next')[0] as HTMLElement);

            if (nextArrow) {
                this.nextArrow = nextArrow;
                this.toggleLastArrow(this.indexOfActiveCarouselItem);
                clearInterval(scanForNextArrowInterval);
            }
        }, 100);
    }

    actualizeActiveItemSize() {
        const carousel: any = this.$refs.carousel;

        if (carousel) {
            const carouselItems = carousel.items;

            if (carouselItems && carouselItems.length) {
                setTimeout(() => {
                    const activeCarouselItem = carouselItems.find(x => x.isActive);

                    this.activeItemWidth = `${activeCarouselItem.$el.offsetWidth}px`;
                    this.activeItemHeight = `${activeCarouselItem.$el.offsetHeight}px`;
                // 300 transition time
                }, 300);
            }
        }
    }

    toggleLastArrow(indexOfActiveCarouselItem) {
        if (!this.infinite
            && this.prevArrow instanceof HTMLElement
            && this.nextArrow instanceof HTMLElement) {
            if (indexOfActiveCarouselItem == 0) {
                this.prevArrow.style.display = 'none';
                this.nextArrow.style.display = 'block';
            } else if (indexOfActiveCarouselItem == this.carouselItems.length - 1) {
                this.prevArrow.style.display = 'block';
                this.nextArrow.style.display = 'none';
            } else {
                this.prevArrow.style.display = 'block';
                this.nextArrow.style.display = 'block';
            }
        }
    }

    checkAndToggleActiveCondition() {
        if (this.breakpoint == undefined) {
            this.carouselIsActive = true;

            return;
        }
        if (window.innerWidth < GridBreakpoints[this.breakpoint]) {
            this.carouselIsActive = true;
        } else {
            this.carouselIsActive = false;
        }
    }

    onChange(index) {
        this.actualizeActiveItemSize();
        this.toggleLastArrow(index);
    }

    @debounce(100)
    onResize() {
        this.actualizeActiveItemSize();
        this.checkAndToggleActiveCondition();
    }
}
